import type { WeSellData } from "../domain/types";

const agora = new Date().toISOString();

export const seed: WeSellData = {
  platforms: [
    {
      id: "platform-amazon",
      slug: "amazon",
      name: "Amazon",
      referralCode: "",
      affiliateUrl: "",
      color: "#ff9900",
      colorStrong: "#8a4f00",
      connectionStatus: "disconnected",
      connectionMode: "official_api",
      lastSyncAt: null,
      nextSyncAt: null,
      notes:
        "Creators API para catálogo e links; relatórios do Associates para vendas e comissão.",
    },
    {
      id: "platform-temu",
      slug: "temu",
      name: "Temu",
      referralCode: "",
      affiliateUrl: "",
      color: "#ff6a00",
      colorStrong: "#9a3f00",
      connectionStatus: "disconnected",
      connectionMode: "local_connector",
      lastSyncAt: null,
      nextSyncAt: null,
      notes:
        "Link e código oficiais, relatório importado e conector local protegido.",
    },
    {
      id: "platform-shein",
      slug: "shein",
      name: "SHEIN",
      referralCode: "",
      affiliateUrl: "",
      color: "#1e1b2e",
      colorStrong: "#1e1b2e",
      connectionStatus: "disconnected",
      connectionMode: "local_connector",
      lastSyncAt: null,
      nextSyncAt: null,
      notes:
        "Os links rastreáveis precisam nascer na área oficial de afiliados da SHEIN.",
    },
  ],
  products: [
    {
      id: "demo-product-1",
      platformId: "platform-temu",
      shortCode: "T001",
      platformProductId: "601099000000001",
      name: "Luminária portátil de mesa",
      description:
        "Exemplo de como um item comprado fica organizado e pronto para divulgar.",
      imageUrl: "/demo-lamp.svg",
      originalUrl: "https://www.temu.com/",
      affiliateUrl: "https://www.temu.com/",
      price: 79.9,
      currency: "BRL",
      category: "Casa e decoração",
      status: "active",
      published: true,
      clicks: 184,
      salesCount: 12,
      commissionTotal: 96.4,
      createdAt: agora,
      updatedAt: agora,
    },
    {
      id: "demo-product-2",
      platformId: "platform-amazon",
      shortCode: "A001",
      platformProductId: "B0DEMO001",
      name: "Microfone sem fio para celular",
      description:
        "Produto de exemplo da vitrine. Troque pelo link real antes de divulgar.",
      imageUrl: "/demo-microphone.svg",
      originalUrl: "https://www.amazon.com.br/",
      affiliateUrl: "https://www.amazon.com.br/",
      price: 219.9,
      currency: "BRL",
      category: "Criação de conteúdo",
      status: "active",
      published: true,
      clicks: 97,
      salesCount: 5,
      commissionTotal: 42.8,
      createdAt: agora,
      updatedAt: agora,
    },
  ],
  contents: [
    {
      id: "demo-content-1",
      title: "Achadinhos que deixaram meu estúdio mais bonito",
      type: "reel",
      channel: "Instagram",
      url: "https://instagram.com/",
      publishedAt: agora,
      productIds: ["demo-product-1", "demo-product-2"],
    },
  ],
  promotions: [
    {
      id: "demo-promotion-1",
      platformId: "platform-temu",
      productId: "demo-product-1",
      contentId: "demo-content-1",
      url: "https://www.temu.com/",
      trackingId: "T001-IG-ESTUDIO",
      clicks: 184,
      validated: true,
      createdAt: agora,
    },
  ],
  sales: [
    {
      id: "demo-sale-1",
      platformId: "platform-temu",
      productId: "demo-product-1",
      promotionId: "demo-promotion-1",
      externalId: "DEMO-001",
      orderDate: agora,
      grossAmount: 79.9,
      commissionAmount: 8.03,
      currency: "BRL",
      status: "approved",
      source: "manual",
      importedAt: agora,
    },
  ],
  imports: [],
  connections: [
    {
      id: "connection-amazon",
      platformId: "platform-amazon",
      mode: "official_api",
      status: "disconnected",
      label: "Amazon Creators API",
      lastSyncAt: null,
      nextSyncAt: null,
      lastError: "",
      fields: {},
    },
    {
      id: "connection-temu",
      platformId: "platform-temu",
      mode: "local_connector",
      status: "disconnected",
      label: "Temu Afiliados + conector local",
      lastSyncAt: null,
      nextSyncAt: null,
      lastError: "",
      fields: {},
    },
    {
      id: "connection-shein",
      platformId: "platform-shein",
      mode: "local_connector",
      status: "disconnected",
      label: "SHEIN Afiliados + conector local",
      lastSyncAt: null,
      nextSyncAt: null,
      lastError: "",
      fields: {},
    },
  ],
  storefront: {
    slug: "laisemesquita",
    title: "Achadinhos da Laise",
    bio: "Produtos que eu realmente comprei e indicaria para uma amiga.",
    disclosure:
      "Como participante do Programa de Associados da Amazon, sou remunerado pelas compras qualificadas efetuadas.",
    active: true,
  },
};
